<template>
  <div>
     <title>批量核销</title>
    <section class="serviceBox">
      <!-- S 券卡验证表单 -->
      <el-form :model="serviceForm" inline class="serviceForm">
        <el-form-item label="序列号段" class="serialInput">
          <el-input v-model="serviceForm.sserial" clearable placeholder="起始序列号"></el-input>
          <small>~</small>
          <el-input v-model="serviceForm.eserial" clearable placeholder="结束序列号"></el-input> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitDeliveryForm()">核销</el-button>
          <i class="iconwh" v-popover:expressWayPop></i>
          <el-popover placement="top" trigger="hover" ref="expressWayPop">
            <p class="greyColor">单次最大核销券卡张数为200。</p>
          </el-popover>
        </el-form-item>
      </el-form>
      <!-- S 券卡验证表单 -->

      <!--S 已核销券卡记录-->
      <div class="serviceWrap" v-show="showRecord">
        <p class="commonTit"><b>已核销券卡记录</b></p>
        <el-table :data="deliveryRecord" ref="cvTable" class="comTable cardVertifyTab" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="订单号" prop="orderDate" sortable min-width="250">
            <template slot-scope="scope">
              <p :title="scope.row.orderno">{{ scope.row.orderno}}</p>
              <small :title="scope.row.orderDate">{{scope.row.orderDate}}</small>
            </template>
          </el-table-column>
          <el-table-column label="券卡编码" min-width="250">
            <template slot-scope="scope">{{ scope.row.code}}</template>
          </el-table-column>
          <el-table-column label="订单内容" prop="orderPrice" sortable min-width="400">
            <template slot-scope="scope">
              <div class="greyColor textFl" :title="scope.row.ordercontent">{{scope.row.ordercontent}}</div>
             <!-- <p class="orderContentI">
                <em class="priceFont"><em>￥</em>{{scope.row.orderPrice}}</em>
              </p> -->
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>	
        </el-table>
      </div>
      <!--S 已核销券卡记录-->              
    </section>

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import Api from "@/apis/api.js";
export default {
  name: 'BulkVerification',
  data(){
    return {
      serviceForm:{
        sserial:'',
				eserial:''
      },
      showRecord:false,
      //已提货券卡记录
      deliveryRecord:[
        
      ],
      tableHeight: window.innerHeight*.8, //表格动态高度
    }
  },
  components: {

  },
  // ============================================== 方法 ==============================================
  methods: {
    //提交表单
    submitDeliveryForm(){
			Api.CARDPICKBYSERIALSANDSUBORDER({startSerial:this.serviceForm.sserial, endSerial:this.serviceForm.eserial}).then(res =>{
				if(res.data.status=="200"){
					 this.deliveryRecord.push(res.data.data);
					 MessageBox.alert(`<div class="alertBox"><p>${res.data.message}</p></div>`, {
					   type: "success",
					   confirmButtonText: '确定',
					   dangerouslyUseHTMLString: true
					 }).then(() => {}).catch(() => {});
					 this.showRecord = true;
					 setTimeout(()=>{
					   this.getHeight();
					 },200)
				}else{
					this.$message.error(res.data.message)
				}
			})
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.cvTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 70; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {

  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>
<style scoped>
.serviceBox {padding: 20px; height:calc(100% - 40px); overflow-y: auto;}
.serviceWrap .commonTit {margin:0 0 10px;}
</style>





// WEBPACK FOOTER //
// src/views/OrderFolder/BulkVerification.vue